import React, { useEffect, useState } from 'react';
import CardsProjectList from '../CardsProjectList/CardsProjectList';
import ProjectsList from '../ProjectsList/ProjectsList';
import { useStyles } from './ProjectsFollowing.Styles';
import './ProjectsFollowing.scss';
import { useTranslation } from 'react-i18next';
import IconButton from '@material-ui/core/IconButton';
import { ReactComponent as ListView } from '../../../assets/icons/u_list-ui-alt.svg';
import { ReactComponent as CardView } from '../../../assets/icons/u_apps.svg';
import SearchInput from '../../Util/CustomInput/SearchInput/SearchInput';
import SearchTabErrorMessage from '../../Util/Errors/SearchTabErrorMessage/SearchTabErrorMessage';
import { EmptyCardsProject } from '../EmptyCardsProject/EmptyCardsProject';
import { tooltipTitle } from '../../../services/stringUtil';
import { isMobile } from '../../../services/booleanUtil';
import useFilters from '../../../hooks/useFilters';
import { withStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import Project from '../../../models/Project';

const BlackTooltip = withStyles({
  tooltip: {
    backgroundColor: '#101319',
    fontSize: '16px',
    fontFamily: 'Rubik',
    lineHeight: '20px',
    padding: '8px 12px',
    borderRadius: '8px',
  },
  arrow: {
    fontSize: 20,
    color: '#4A4A4A',
    '&::before': {
      backgroundColor: '#101319',
    },
  },
})(Tooltip);

const ProjectsFollowing = () => {
  const followedProjects = useSelector<any, Project[]>(state => state.followedProjects);
  const { filter, dispatch, setFilter } = useFilters();
  const { t } = useTranslation();
  const { cardsListButton } = useStyles();
  const [cardView, setCardView] = useState(filter.followedProjectsFilter.cardView);
  const haveProjectsFollowed = filter.followedProjectsPagination.rowCount === 0 ? false : true;
  const itsSearch = filter.common.itSearch;
  const searchValue = filter.followedProjectsFilter.searchValue;

  const switchView = () => {
    dispatch(
      setFilter({
        ...filter,
        followedProjectsFilter: {
          ...filter.followedProjectsFilter,
          cardView: !filter.followedProjectsFilter.cardView,
        },
      }),
    );
    setCardView(!filter.followedProjectsFilter.cardView);
  };

  const renderOptions = () => {
    if (!haveProjectsFollowed && !itsSearch) {
      return (
        <div className="following-container-options">
          <EmptyCardsProject />
        </div>
      );
    }

    return (
      <div className={"following-container-options" + (!cardView ? " cards-hidden" : "")}>
        {/* <div className="title-projects">{t('following_projects_title')}</div> */}
        {!isMobile() && (
          <div className="title-options-projects-following">
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <IconButton className={cardsListButton} onClick={switchView}>
                  {cardView ? (
                    <BlackTooltip
                      title={tooltipTitle(t, 'view_list')}
                      placement="bottom"
                      enterDelay={500}
                      leaveDelay={200}
                      arrow
                    >
                      <span className='btn-sm btn-primary-text'>
                        <ListView id="listView" /> {t('view_list')}
                      </span>
                    </BlackTooltip>
                  ) : (
                    <BlackTooltip
                      title={tooltipTitle(t, 'view_card')}
                      placement="bottom"
                      enterDelay={500}
                      leaveDelay={200}
                      arrow
                    >
                      <span className='btn-sm btn-primary-text'>
                        <CardView id="switchView" /> {t('view_card')}
                      </span>
                    </BlackTooltip>
                  )}
                </IconButton>
                {(cardView || (!haveProjectsFollowed && itsSearch)) && <SearchInput itsFollowed={true} />}
              </div>
              {!haveProjectsFollowed ? <div className='pt-3'><SearchTabErrorMessage search={searchValue} /></div> : null}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={isMobile() ? { padding: '15px 0px 15px 0px' } : {}}>
      {renderOptions()}
      {cardView ? (
        <CardsProjectList itsSearch={itsSearch} />
      ) : (
        <div className="following-container-list">
          <ProjectsList itsSearch={itsSearch} />
        </div>
      )}
    </div>
  );
};

export default ProjectsFollowing;
